export default __webpack_public_path__ + "static/media/4.56a5a5ea.png";